module.exports = require('../dist/components/Tooltip/Tooltip');
